<template>
  <div>
    <avtalat-select id="ovriga-samtalsamnen" :label="label" @update:value="push">
      <option v-if="placeholder" value="" disabled>
        {{ placeholderOrCount }}
      </option>
      <option
        v-for="(item, key) in options"
        :key="key"
        :value="item.id"
        :disabled="currentSelected?.includes(item.id)"
      >
        {{ item.label }}
      </option>
    </avtalat-select>
    <ChipsContainer class="mt-sm" v-if="currentSelected.length > 0">
      <ChipsItem
        v-for="(id, idx) in currentSelected"
        :removable="!initiallySelected.find((item) => item === id)"
        :key="idx"
        @remove="remove(idx)"
        >{{ chipLabel(id) }}</ChipsItem
      >
    </ChipsContainer>
  </div>
</template>
<script setup lang="ts">
import { type Ref, computed, onBeforeMount, ref } from "vue";

import ChipsContainer from "@/components/ui/ChipsContainer.vue";
import ChipsItem from "@/components/ui/ChipsItem.vue";
import type { Option } from "@/types/form";

type PropTypes = {
  label: string;
  placeholder?: string;
  options: Option[];
  selected: (string | number)[];
};

const props = defineProps<PropTypes>();
const emit = defineEmits(["push", "remove"]);

const push = (value: string) => emit("push", value);
const remove = (idx: number) => emit("remove", idx);

const initiallySelected: Ref<(string | number)[]> = ref([]);

onBeforeMount(() => {
  initiallySelected.value = [...props.selected];
});

const currentSelected = computed(() => {
  return Array.from(new Set([...initiallySelected.value, ...props.selected]));
});

const chipLabel = (id: string | number) =>
  props.options.find((option) => option.id === id)?.label;

const placeholderOrCount = computed(() => {
  const selectedCount = currentSelected.value.length;
  switch (selectedCount) {
    case 0:
      return props.placeholder;
    case 1:
      return `${selectedCount} vald`;
    default:
      return `${selectedCount} valda`;
  }
});
</script>
